import { Button } from "./Button";

/**
 * Prev/next pager for offset+limit list endpoints. Pairs with the
 * `{ rows, total, limit, offset }` response shape used across
 * /contacts, /tasks, /opportunities, /payments, /payments/invoices,
 * and /automations/:id/runs.
 *
 * Renders nothing when the result set fits on one page so the caller
 * doesn't have to guard at the call site.
 */
export function Paginator({
  total, limit, offset, onChange, className,
}: {
  total: number;
  limit: number;
  offset: number;
  onChange: (nextOffset: number) => void;
  className?: string;
}) {
  if (total <= limit) return null;
  const start = total === 0 ? 0 : offset + 1;
  const end = Math.min(offset + limit, total);
  return (
    <div className={"flex items-center justify-between text-sm text-zinc-500 " + (className ?? "")}>
      <span>
        Showing {start.toLocaleString()}–{end.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={offset + limit >= total}
          onClick={() => onChange(offset + limit)}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
